export default {
  'de-AT': '',
  'de-CH': '',
  'de-DE': '',
  'fi-FI': '',
  'fr-BE': '',
  'fr-CH': '',
  'fr-FR': '',
  'nl-BE': '',
  'nl-NL': '',
}
